import Link from "next/link";
import ChangePlan from "./membership/ChangePlan";

export default function MemberPerks({ className }) {
  return (
    <article className={`bg-white mb-8 p-6 rounded shadow-md ${className}`}>
      <p className="text-sm">
        Want access to the Uncovered knowledge base? Join a research group?
        Upgrade your membership.
      </p>
      <ChangePlan
        upgrade={true}
        className="mt-4 w-full bg-black border-black text-white hover:text-red-500 font-semibold"
      >
        Upgrade Membership
      </ChangePlan>
      <Link href="/membership">
        <a className="block font-semibold mt-2 text-sm text-center">
          See Membership Details
        </a>
      </Link>
    </article>
  );
}
